import { ContentPart } from "../content-part";

export class ContentCaption extends ContentPart {
  public constructor(id: string) {
    super(id, "Caption");
  }
}
